import { default as http } from "../rest/http";

export interface NotificationsQueryParams {
  orgId: number;
  page: number;
  perPage: number;
  status?: string;
  type?: string;
  userId?: string;
}

// GET /transaction-service/admin/notifications
// orgId is required; status/type/userId are optional server-side filters.
export const fetchNotifications = async (params: NotificationsQueryParams) => {
  const query = new URLSearchParams();
  query.append("orgId", String(params.orgId));
  query.append("page", String(params.page));
  query.append("perPage", String(params.perPage));
  if (params.status) query.append("status", params.status);
  if (params.type) query.append("type", params.type);
  if (params.userId) query.append("userId", params.userId);

  const url = `/transaction-service/admin/notifications?${query.toString()}`;
  const response = await http.get(url);
  return response;
};
